<template>
  <section class="bugallery">
    <div class="bugallery-wrapper py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 butextual-info__text">
            <div
              v-if="item.itemable.slides.length > 0"
              class="images d-flex flex-wrap justify-content-center align-items-start"
            >
              <img
                v-for="(img, index) in item.itemable.slides"
                v-img:group
                :key="index"
                :src="img.photo_url"
                width="120"
                class="img-fluid my-2 mx-2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ec-business-gallery',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      title: 'Dit is het ec-business-textual component.'
    }
  }
}
</script>
